export default {
    name: "teleport-comp",
    props: {
      to: {
        type: String,
        required: true
      },
      isPrependChild:{
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        isMounted: false
      }
    },
    mounted() {
      this.isMounted = true
      if(this.isPrependChild){
        const ToElement = document.querySelector(this.to)
        ToElement.insertBefore(this.$el, ToElement.firstChild)
      }else{
        document.querySelector(this.to).appendChild(this.$el)
      }
    },
    activated() {
      if (this.isMounted) return
      if(this.isPrependChild){
        const ToElement = document.querySelector(this.to)
        ToElement.insertBefore(this.$el, ToElement.firstChild)
      }else{
        document.querySelector(this.to).appendChild(this.$el)
      }
    },
    // 路由切换移除
    deactivated() {
      this.isMounted = false
      this.$el && this.$el.parentNode && this.$el.parentNode.removeChild(this.$el)
    },
    render() {
      return <div class="teleport">{this.$scopedSlots.default()}</div>
    },
    destroyed() {
      this.isMounted = false
      this.$el && this.$el.parentNode && this.$el.parentNode.removeChild(this.$el)
    }
  }
  